import axios from '@/plugins/axios';
import ErrorHandle from '@/helpers/errors/errorHandle';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  bookingsListData: {},
  bookingsStatuses: [],
  bookingsTypes: [],
  cancelBookingId: null,
  cancelBookingDialogState: false,
  cancelBookingLoader: false,
  cancelBookingDetails: {},
};
const getters = {
  getBookingsListData: (state) => state.bookingsListData,
  getBookingsStatuses: (state) => state.bookingsStatuses,
  getBookingsTypes: (state) => state.bookingsTypes,
  getCancelBookingId: (state) => state.cancelBookingId,
  getCancelBookingDialogState: (state) => state.cancelBookingDialogState,
  getCancelBookingLoader: (state) => state.cancelBookingLoader,
  getCancelBookingDetails: (state) => state.cancelBookingDetails,
};

const mutations = {
  setBookingsListData(state, data) {
    state.bookingsListData = data;
  },
  setBookingsStatuses(state, data) {
    state.bookingsStatuses = data;
  },
  setBookingsTypes(state, data) {
    state.bookingsTypes = data;
  },
  setCancelBookingId(state, data) {
    state.cancelBookingId = data;
  },
  setCancelBookingDialogState(state, data) {
    state.cancelBookingDialogState = data;
  },
  setCancelBookingLoader(state, data) {
    state.cancelBookingLoader = data;
  },
  setCancelBookingDetails(state, data) {
    state.cancelBookingDetails = data;
  },
};

/* eslint-disable no-unused-vars */
const actions = {
  async fetchBookingsListData({ commit }, credentials) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const searchString = credentials.searchString
        ? encodeURIComponent(credentials.searchString)
        : '';
      const page = credentials.page ? credentials.page : '';
      const bookingStatus = credentials.bookingStatus
        ? credentials.bookingStatus
        : '';
      const bookingDate = credentials.bookingDate
        ? credentials.bookingDate
        : '';
      const bookingType = credentials.bookingType
        ? credentials.bookingType
        : '';
      const data = await axios.get(
        `/reservations?page=${page}&searchString=${searchString}&status=${bookingStatus}&date=${bookingDate}&type=${bookingType}`,
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      const bookingsListData = {
        ...data.data.data.reservations,
        items: enumerateArray(
          data.data.data.reservations.items,
          data.data.data.reservations.currentPage,
          data.data.data.reservations.perPage,
        ),
      };

      commit('setBookingsListData', bookingsListData);
      commit('global/setLoader', false, { root: true });
      return bookingsListData;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  async fetchBookingsProperties({ commit }) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.get('/reservations/properties', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const { status, type } = data.data.data.properties;

      commit('setBookingsStatuses', status);
      commit('setBookingsTypes', type);
      commit('global/setLoader', false, { root: true });
      return data;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  async cancelBooking({ commit }, bookingId) {
    try {
      commit('setCancelBookingLoader', true);
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.post(`/reservations/${bookingId}/cancel`, null, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const cancelBooking = data.data.data;

      commit('setCancelBookingDetails', cancelBooking);
      commit('setCancelBookingLoader', false);
      return data;
    } catch (error) {
      commit('setCancelBookingLoader', false);
      throw ErrorHandle(error, this);
    }
  },
  async confirmCancelBooking({ commit }, credentials) {
    try {
      commit('setCancelBookingLoader', true);
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.patch(
        `/reservations/${credentials.id}/cancel`,
        { token: credentials.token },
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      const { message } = data.data.data;
      commit('setCancelBookingLoader', false);
      return message;
    } catch (error) {
      commit('setCancelBookingLoader', false);
      throw ErrorHandle(error, this);
    }
  },
  /* eslint-disable no-unused-vars */
  async fetchBookingData({ commit }, bookingId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.get(`/reservations/${bookingId}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return response.data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
